<template>
  <div>
    <span class="is-bold">{{$t('auth.logging_out')}}</span>
  </div>
</template>

<script>
import LocalStorageHelper from "../../../local-storage/LocalStorageHelper";
import * as LocalStorageKeys from "../../../local-storage/LocalStorageKeys";
import SocketioService from "@/services/socketio.service";
export default {
  mounted () {
    if (this.$auth) {
      this.$auth.logout({
        redirect: { name: 'login' },
        success: function () {
          SocketioService.disconnect()
          if (this.$socket) {
            this.$socket.close()
          }
          this.$router.resetRouter()
          this.$store.dispatch('LOGOUT')
          LocalStorageHelper.remove(LocalStorageKeys.REFRESH_AUTH_TOKEN)
        }
      })
    }
  }
}
</script>

<style lang="scss">
</style>
